import { Box, Typography } from '@mui/material';
import { MatchResultPlayerStatus } from '@okletsplay/core';
import classNames from 'classnames';
import { MATCH_RESULT_PLAYER_STATUS_TEXT } from 'modules/matches/constants';
import React, { FC } from 'react';
import { useStyles } from './PlayerResultStatus.styles';

interface PlayerStatusProps {
  status: MatchResultPlayerStatus;
}

export const PlayerResultStatus: FC<PlayerStatusProps> = ({ status }) => {
  const { classes } = useStyles();

  if (!status) {
    return null;
  }

  return (
    <Box className={classNames(classes.root, classes[status])}>
      <Typography className={classes.status}>{MATCH_RESULT_PLAYER_STATUS_TEXT[status]}</Typography>
    </Box>
  );
};
